import React, {useState} from "react";
import PhoneInput from 'react-phone-input-2';
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";

const ContactForm = () =>{

    const navigate = useNavigate();

    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [message, setMessage] = useState("");
    const [status, setStatus] = useState("");
    const [isSubmit, setIsSubmit] = useState(false);

    const handleName = (e) =>{

  		setName(e.target.value);
  	}

  	const handleEmail = (e) =>{

  		setEmail(e.target.value);
  	}

  	const handlePhone = (e) =>{
  		console.log(':::' + e);
  		setPhone(e);
  	}

  	const handleMessage = (e) =>{

  		setMessage(e.target.value);
  	}

    const sendEmail = async (e) => {
    
		e.preventDefault();
	
		setIsSubmit(true);

		// Prepare FormData object
		const formData = new FormData();
		formData.append("name", name);
		formData.append("email", email);
		formData.append("phone", phone);
		formData.append("message", message);


		try 
		{
			const response = await axios.post("https://entdelhi.com/mailer/mailer.php", formData);
			
			if (response.data.success) 
			{
				setStatus("Message sent successfully!");
				// Reset form state
				setName("");
				setEmail("");
				setPhone("");
				setMessage("");				

				navigate("/thank-you");
			} 
			else 
			{
				setStatus("Failed to send message.");
				console.error(response.data.error);
			}
			
			setIsSubmit(false);
		} 
		catch (error) 
		{
			setStatus("Something went wrong!");
			console.error("Axios error:", error);
		}
	};

    return(
    <div className="form-section">
        <h4 className="mb-3" style={{ fontSize: '20px', fontWeight: 'bold', textAlign: 'center' }}>Appointment with  Dr. (Major) Rajesh Bhardwaj</h4>
        <form onSubmit={sendEmail}>

            <div className="mb-3">
                <input type="text" className="form-control" placeholder="Patients Name" name="name" required value={name} onChange={handleName} />
            </div>

            <div className="mb-3">
                <input type="email" className="form-control" placeholder="Enter your email" name="email" required value={email} onChange={handleEmail} />
            </div>

            <div className="mb-3">
                {/*<input id="phone" type="tel" className="form-control" placeholder="Your Phone Number" name="phone" required value={formDataState.phone} onChange={handleChange} maxLength="13" onInput={(e) => {
                    e.target.value = e.target.value.replace(/\D/g, "");
                }} />*/}
                
                <PhoneInput country={'in'} value={phone} onChange={handlePhone} maxLength="13" placeholder="Your Phone Number" name="phone" id="phone" required />
                
            </div>

            <div className="mb-3">
                <textarea id="message" className="form-control" name="message" rows="3" cols="40" placeholder="Describe Your Problems" value={message} onChange={handleMessage}></textarea>

            </div>

            <div className="mb-2">
                <div className="form-check">									
                    <input className="form-check-input" type="checkbox" id="policy" required />
                    <label className="form-check-label" htmlFor="policy">
                    I agree to the terms in the <Link to="#">Privacy Policy</Link>
                    </label>
                </div>
                <div className="form-check">
                    <input className="form-check-input" type="checkbox" id="offers" />
                    <label className="form-check-label" htmlFor="offers">
                        I would like MedFirst ENT Centre to send me information about ENT solutions, services and offers.
                    </label>
                </div>
            </div>
            {/*<button type="submit" class="btn btn-submit mt-2">Book Appointment Now</button>*/}
            {!isSubmit && <button type="submit" className="btn btn-submit mt-2">Book Appointment Now</button>}
            {isSubmit && 
                <button type="submit" className="btn btn-submit mt-2" disabled={true}>
                    <div className="ms-4 spinner-border text-light" role="status">
                        <span className="sr-only">Loading...</span>
                    </div>
                </button>
            }
        </form>
    </div>
    );
}

export default ContactForm;